import { forwardRef, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useLazyQuery } from "@apollo/client/react";
import { GET_PUBLIC_PLATFORM_INFO } from "../../graphql/auth.js";

// Renders nothing when the admin has reCAPTCHA toggled off or hasn't
// configured a site key yet, so callers don't need their own on/off check.
// The ref is forwarded straight to the underlying ReCAPTCHA so callers can
// call .reset() after a failed submit (v2 tokens are single-use).
export const RecaptchaWidget = forwardRef(({ onChange }, ref) => {
  const [fetchInfo, { data }] = useLazyQuery(GET_PUBLIC_PLATFORM_INFO);

  useEffect(() => { fetchInfo(); }, []);

  const info = data?.getPublicPlatformInfo?.data;
  if (!info?.showRecaptcha || !info?.recaptchaSiteKey) return null;

  return (
    <div className="flex justify-center">
      <ReCAPTCHA
        ref={ref}
        sitekey={info.recaptchaSiteKey}
        onChange={onChange}
        onExpired={() => onChange(null)}
      />
    </div>
  );
});
RecaptchaWidget.displayName = "RecaptchaWidget";
